import React, { useEffect, useContext, useState } from 'react';
import Mapping from '../../../locales/messages/mapping';
import { Loader } from '../../commonComponents';
import { API_DETAILS, language } from 'Root/constants';
import VMContext from '../context';
import { isIFRAMEUrl, defineTypeCase } from 'Root/utils';

function addScript() {
  return new Promise((resolve, reject) => {
    (function (d, k) {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `${API_DETAILS.apiEndpoint}${k}`;
      s.onload = () => {
        resolve();
      };
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    })(document, API_DETAILS.accessKey);
  });
}

function getLangCode() {
  return Mapping[language];
}

function getFrame() {
  let frameWidth = 300;
  let frameHeight = 380;

  if (window.innerWidth > 320 && window.innerWidth < 361) {
    frameWidth = 320;
  } else if (window.innerWidth > 360 && window.innerWidth < 376) {
    frameWidth = 330;
  } else if (window.innerWidth > 375 && window.innerWidth < 767) {
    frameWidth = 360;
  } else if (window.innerWidth > 767 && window.innerWidth < 992) {
    frameWidth = 480;
    frameHeight = 520;
  } else if (window.innerWidth > 991) {
    frameWidth = 360;
    frameHeight = 480;
  }
  if (isIFRAMEUrl() && defineTypeCase() == 'seven') {
    if (window.innerWidth > 375 && window.innerWidth < 767) {
      frameWidth = 300;
      frameHeight = 360;
    } else if (window.innerWidth > 767 && window.innerWidth < 992) {
      frameWidth = 300;
      frameHeight = 360;
    } else {
      frameWidth = 300;
      frameHeight = 360;
    }
  }
  return [frameWidth, frameHeight];
}

function initYMK() {
  const vmLangCode = getLangCode();
  const [frameWidth, frameHeight] = getFrame();
  const SHOW_PC_SEND_EMAIL =
    process.env.REACT_APP_SHOW_PERFECTCORP_SEND_MAIL || 'no';
  window.YMK.init({
    autoOpen: false,
    language: vmLangCode,
    height: frameHeight,
    width: frameWidth,
    disable2ColorComparison: true,
    showCompareCaption: false,
    enableEmailSharing: SHOW_PC_SEND_EMAIL === 'yes' ? true : false,
    intensitySliderDisplayMode:
      process.env.REACT_APP_YMKSLIDER_ENABLE === 'yes' ? 'enabled' : 'disabled',
  });
  window.YMK.open();
}

const emptyFunc = () => null;

const useInitYMK = ({
  onLoaded = emptyFunc,
  onEngineClosed = emptyFunc,
  onReset = emptyFunc,
  onCompare = emptyFunc,
  onLibLoaded = emptyFunc,
}) => {
  const [YMKInit, setYMKInit] = useState(false);
  useEffect(() => {
    if (window.YMK) {
      window.YMK.addEventListener('loaded', onLoaded);
      window.YMK.addEventListener('engineClosed', onEngineClosed);
      window.YMK.addEventListener('reset', onReset);
      window.YMK.addEventListener('compare', onCompare);

      return function cleanup() {
        window.YMK.removeEventListener('loaded');
        window.YMK.removeEventListener('engineClosed');
        window.YMK.removeEventListener('reset');
        window.YMK.removeEventListener('compare');
      };
    }
  }, [YMKInit]);
  useEffect(() => {
    window.ymkAsyncInit = initYMK;
    addScript().then(() => {
      onLibLoaded();
      setYMKInit(true);
    });
  }, []);
};

const Perfectcorp = ({
  onLoaded,
  onEngineClosed,
  onReset,
  onCompare,
  onLibLoaded: libLoaded,
  vmRef = null,
}) => {
  const { loader, setVmState } = useContext(VMContext);
  const onLibLoaded = () => {
    setVmState({ loader: false });
    libLoaded();
  };
  useInitYMK({
    onLoaded,
    onEngineClosed,
    onReset,
    onCompare,
    onLibLoaded,
  });

  return (
    <section className="content--component__ymk-module-inner">
      {loader && <Loader />}
      {/** --------------VM IFrame----------------------------- */}
      <div
        id="YMK-module"
        ref={vmRef}
        className="content--component__ymk-wrapper"
      ></div>
    </section>
  );
};

export default Perfectcorp;
